import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useLanguage, useAuth, useListingRoom } from 'hooks';
import { hideModal } from 'state/actions';
import { ALERT, COLOR, MODAL, ENG, EN, FR } from 'config/constants';
import { HvModal, HvButton } from 'components';
import { FLOORING } from 'models/Room';

const useStyles = makeStyles({
  description: {
    fontSize: 14,
    fontFamily: 'FordAntenna-Medium',
  },
  confirmation: {
    fontSize: 14,
    marginBottom: 20,
  },
  cancelButton: {
    backgroundColor: 'white',
    marginRight: 20,
    color: COLOR.LIGHT_BLUE,
    border: '1px solid #00bdf2',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
});

function ChangeFloorTypeModal(props) {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const language = useLanguage();

  const { token } = useAuth();
  const { room, floor_type } = props;

  const { updateFloorplanRoom } = useListingRoom(token);
  const fmtModalTitle = intl.formatMessage({ id: 'deliver.changeFloorType.title' });
  const fmtConfirm = intl.formatMessage({ id: 'deliver.changeFloorType.confirm' });
  const fmtCancel = intl.formatMessage({ id: 'deliver.changeFloorType.cancel' });
  const fmtDescription = intl.formatMessage({ id: 'deliver.changeFloorType.description' });
  const fmtRoom = intl.formatMessage({ id: 'deliver.changeFloorType.room' });
  const fmtFloorType = intl.formatMessage({ id: 'deliver.changeFloorType.floorType' });

  const onClose = () => {
    dispatch(hideModal(MODAL.CHANGE_FLOOR_TYPE));
  };

  const onConfirm = async () => {
    updateFloorplanRoom(room.id, floor_type);
    dispatch(hideModal(MODAL.CHANGE_FLOOR_TYPE));
  };

  const getFloorType = () => {
    const key = language === ENG ? EN : FR;
    const type = FLOORING.find((m) => {
      return m.key === floor_type;
    });
    return type ? type[key] : null;
  };

  const buttons = (
    <div>
      <HvButton onClick={onClose} className={classes.cancelButton}>
        {fmtCancel}
      </HvButton>
      <HvButton onClick={onConfirm} disabled={!room.id || !floor_type}>
        {fmtConfirm}
      </HvButton>
    </div>
  );

  return (
    <HvModal title={fmtModalTitle} buttons={buttons} onClose={onClose}>
      <Typography className={classes.confirmation}>{fmtDescription}</Typography>
      <div className={classes.row}>
        <Typography className={classes.description}>
          {`${fmtRoom}: ${room.getRoomName(language)}`}
        </Typography>
        <Typography className={classes.description}>
          {`${fmtFloorType}: ${getFloorType()}`}
        </Typography>
      </div>
    </HvModal>
  );
}
export default ChangeFloorTypeModal;
